import React from 'react';

const TargetAudience = () => {
  const businesses = [
    {
      title: "Restaurantes y Cafeterías",
      description: "Optimiza pedidos, mesas y cocina con nuestro sistema integrado",
      icon: "🍽️"
    },
    {
      title: "Barberías y Salones",
      description: "Gestión de citas, clientes y ventas en un solo lugar",
      icon: "✂️"
    },
    {
      title: "Tiendas Minoristas",
      description: "Control de inventario y ventas con reportes automáticos",
      icon: "🛒"
    },
    {
      title: "MYPES",
      description: "Soluciones personalizadas para tu modelo de negocio",
      icon: "🏢"
    }
  ];

  return (
    <section className="py-20 px-4 bg-[#E1F5FE]">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-4 text-[#03ADED]">
          ¿Para quién es YupiSoft?
        </h2>
        <p className="text-xl text-center mb-12 text-gray-600 max-w-3xl mx-auto">
          Nuestras soluciones están diseñadas para negocios peruanos que buscan crecer con tecnología simple pero poderosa.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {businesses.map((business, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-[#B3E5FC]"
            >
              <div className="text-4xl mb-4">{business.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-gray-800">{business.title}</h3>
              <p className="text-gray-600">{business.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;